
import React from "react";
import { ImportanceColorSettings } from "@/components/profile/ImportanceColorSettings";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function ImportanceColorsStep() {
  return (
    <div className="space-y-4">
      <p>
        Contract importance levels are visually indicated with colors. You can customize
        these colors to match your preferences or company branding.
      </p>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-lg">Importance Color Settings</CardTitle>
          <CardDescription>
            Choose colors for different contract importance levels
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ImportanceColorSettings />
        </CardContent>
      </Card>
      
      <p className="text-sm text-muted-foreground">
        The colors help you quickly identify high-priority contracts in lists and reports.
      </p>
    </div>
  );
}
